import SrsCodesPage from './SrsCodes.page.vue'
import SrsCodesDetailsPage from './{id}/SrsCodesDetailsPage.vue'

export const SrsCodesRoutes = [
    {
        path: '/app/srsCodes',
        component: SrsCodesPage
    },
    {
        path: '/app/srsCodes/:product',
        component: SrsCodesDetailsPage,
    },
]
